module.exports = __webpack_public_path__ + "img/search_icon.2ff2f499.png";